<template>
  <canvas ref="canvas" :style="{ width: '100%', height: height + 'px' }" />
</template>

<script setup>
import { ref, onMounted, watch, nextTick } from 'vue';
import { Chart, LineController, LineElement, PointElement, LinearScale, CategoryScale, Filler, Tooltip } from 'chart.js';

Chart.register(LineController, LineElement, PointElement, LinearScale, CategoryScale, Filler, Tooltip);

const props = defineProps({
  data: { type: Array, default: () => [] },
  height: { type: Number, default: 120 },
});

const canvas = ref(null);
let chartInstance = null;

function render() {
  if (!canvas.value || !props.data || props.data.length < 2) return;

  const prices = props.data;
  const up = prices[prices.length - 1] >= prices[0];
  const color = up ? '#22c55e' : '#ef4444';
  const colorFaded = up ? 'rgba(34, 197, 94, 0.08)' : 'rgba(239, 68, 68, 0.08)';

  if (chartInstance) chartInstance.destroy();

  chartInstance = new Chart(canvas.value, {
    type: 'line',
    data: {
      labels: prices.map((_, i) => i),
      datasets: [{
        data: prices,
        borderColor: color,
        borderWidth: 2,
        backgroundColor: colorFaded,
        fill: true,
        tension: 0.3,
        pointRadius: 0,
        pointHitRadius: 8,
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: false },
        tooltip: {
          enabled: true,
          mode: 'index',
          intersect: false,
          callbacks: {
            label: (ctx) => '$' + ctx.parsed.y.toFixed(ctx.parsed.y > 1 ? 2 : 6),
            title: () => '',
          },
          displayColors: false,
          padding: 6,
          bodyFont: { size: 12, family: "'SF Mono', Monaco, monospace" },
        },
      },
      scales: {
        x: { display: false },
        y: { display: false },
      },
      interaction: { mode: 'index', intersect: false },
      animation: { duration: 0 },
      layout: { padding: 0 },
    }
  });
}

onMounted(() => nextTick(render));
watch(() => props.data, () => nextTick(render), { deep: true });
</script>
